import ReduxQuerySync, { InitialTruth } from './reduxQuerySync';
import { createBrowserHistory } from 'history';

import * as listActions from '../../List/listActions';
import * as listSelectors from '../../List/listSelectors';
import { initialState as initialListState } from '../../List/listReducer';

import * as filterActions from '../../Filter/filterActions';
import * as filterSelectors from '../../Filter/filterSelectors';
import { defaultInitialState } from '../../Filter/filterReducer';

import * as appConfigActions from '../../AppConfig/appConfigActions';
import * as appConfigSelectors from '../../AppConfig/appConfigSelectors';
import { initialState as initialAppConfigState } from '../../AppConfig/appConfigReducer';

import * as comparisonActions from '../../Comparison/comparisonActions';
import * as comparisonSelectors from '../../Comparison/comparisonSelectors';

import {
    convertQueryStringToDynamicFilters,
    convertDynamicFiltersToQueryString,
    convertQueryStringToSelectedValues,
    convertSelectedValuesToQueryString,
    convertSearchStringToValue,
    convertSearchValueToQueryString,
    convertStartsWithValueToQueryString,
} from './querySyncFormatters';

export const history = createBrowserHistory();

export const initialTruth = InitialTruth.location;

export const params = {
    curriculumType: {
        action: listActions.setActiveSlug,
        selector: listSelectors.activeCTSlugSelector,
        defaultValue: initialListState.activeSlug,
    },
    search: {
        action: filterActions.updateSearchTerm,
        selector: filterSelectors.searchTermSelector,
        defaultValue: defaultInitialState.searchTerm,
        stringToValue: convertSearchStringToValue,
        valueToString: convertSearchValueToQueryString,
    },
    startsWith: {
        action: filterActions.updateStartsWith,
        selector: filterSelectors.startsWithSelector,
        defaultValue: defaultInitialState.startsWith,
        valueToString: convertStartsWithValueToQueryString,
        stringToValue: convertStartsWithValueToQueryString,
    },
    view: {
        action: appConfigActions.setAppView,
        selector: appConfigSelectors.appViewSelector,
        defaultValue: initialAppConfigState.view,
    },
    page: {
        action: filterActions.setActivePage,
        selector: filterSelectors.activePageIndexSelector,
        defaultValue: defaultInitialState.activePageIndex,
    },
    filters: {
        action: filterActions.setDynamicFilters,
        selector: filterSelectors.dynamicFiltersSelector,
        defaultValue: defaultInitialState.dynamicFilters,
        stringToValue: convertQueryStringToDynamicFilters,
        valueToString: convertDynamicFiltersToQueryString,
    },
    selected: {
        action: comparisonActions.setSelectedItems,
        selector: comparisonSelectors.comparisonSelectedUuidsSelector,
        defaultValue: [],
        stringToValue: convertQueryStringToSelectedValues,
        valueToString: convertSelectedValuesToQueryString,
    },
};

export const querySyncEnhancer = ReduxQuerySync.enhancer({
    params,
    initialTruth,
    history,
});
